import axios from 'axios'
import API from '@s/API'
import Vue from 'vue'
import _remove from 'lodash/remove'

const state = {
    users: [],
    config: {
        perpage: 10,
        fields: [],
        page: 1,
        filter: {
            like: [],
            equals: []
        },
        sort: []
    },
    pagination: {},


    selectedUser: {
        email: "",
        id: null,
        login: "",
        name: "",
        phone: "",
        auth: {
            provider: 'password',
            secret: ''
        },
        bloque:null,
        customs: {
            champ1: null,
            champ2: null,
            champ3: null,
            champ4: null,
            champ5: null,
        },
        theme:null
    },
    clientUserCustoms: {},
    selectedUserRoles: {},
    selectedUserGroupsOrig: {},
    selectedUserGroups: {}

}

const getters = {
    users: state => {
        return state.users;
    },
    config: state => {
        return state.config;
    },
    pagination: state => {
        return state.pagination;
    },


    selectedUser: state => {
        return state.selectedUser
    },
    selectedUserRoles: state => {
        return state.selectedUserRoles
    },
    selectedUserGroups: state => {
        return state.selectedUserGroups
    }


}

const mutations = {
    users(state, payload) {
        state.users = payload
    },
    pagination(state, payload) {
        state.pagination = payload
    },
    config(state, payload) {
        state.config = payload
    },
    configPerpage(state, payload) {
        state.config.perpage = payload;
    },
    configFields(state, payload) {
        state.config.fields = payload;
    },
    configPage(state, payload) {
        state.config.page = payload;
    },
    configFilter(state, payload) {
        state.config.page = 1;
        state.config.filter = payload;
    },
    configSort(state, payload) {
        state.config.sort = payload;
    },
    configFilterLike(state, payload) {
        state.config.page = 1;
        state.config.filter.like = payload;
    },
    configFilterEquals(state, payload) {
        state.config.page = 1;
        state.config.filter.equals = payload;
    },

    resetPagination(state) {
        state.pagination = {}
    },

    resetConfig(state) {
        state.config = {
            perpage: 10,
            fields: [],
            page: 1,
            filter: {
                like: [],
                equals: []
            },
            sort: []
        }

    },


    selectedUser(state, payload) {
        let customs = state.selectedUser.customs;
        customs = {...customs, ...payload.customs};
        state.selectedUser = {...payload};
        state.selectedUser.customs = customs;
    },

    selectedUserField(state, payload) {
        Vue.set(state.selectedUser,payload.field,payload.value)
    },

    selectedUserAuthField(state, payload) {
        Vue.set(state.selectedUser.auth,payload.field,payload.value)
    },

    selectedUserAddId(state, payload) {
        state.selectedUser.id = payload;
    },


    selectedUserRoles(state, payload) {
        state.selectedUserRoles = payload;
    },

    selectedUserGroups(state, payload) {

        if (!state.selectedUserGroups[payload.universe]) {
            Vue.set(state.selectedUserGroups, payload.universe, []);
            Vue.set(state.selectedUserGroupsOrig, payload.universe, []);
        }

        state.selectedUserGroups[payload.universe] = payload.groups;
        state.selectedUserGroupsOrig[payload.universe] = JSON.parse(JSON.stringify(payload.groups));
    },

    addGroup(state, payload) {
        if (!state.selectedUserGroups[payload.universe]) {
            Vue.set(state.selectedUserGroups, payload.universe, []);
        }
        state.selectedUserGroups[payload.universe].push(payload.group);
    },

    removeGroup(state, payload) {
        _remove(state.selectedUserGroups[payload.universe], value => {
            return value.id === payload.group.id
        })

    },

    changeRole(state, payload) {

        //state.selectedUserRoles[payload.universe].push(payload.role);
        if (payload.role == null) {
            Vue.set(state.selectedUserRoles, payload.universe, [])
        }
        else {
            if (!state.selectedUserRoles[payload.universe]) {
                Vue.set(state.selectedUserRoles, payload.universe, []);
                //state.selectedUserRoles[payload.universe] = [];
            }
            Vue.set(state.selectedUserRoles[payload.universe], 0, payload.role);
            //state.selectedUserRoles[payload.universe][0] = payload.role;
        }
    },

    clearSelectedUser(state) {
        state.selectedUser = {
            email: "",
            id: null,
            login: "",
            name: "",
            phone: "",
            auth: {
                provider: 'password',
                secret: ''
            },
            customs: {
                champ1: null,
                champ2: null,
                champ3: null,
                champ4: null,
                champ5: null,
            }
        }

        state.selectedUserRoles = {}

        state.selectedUserGroups = {}
    },

    initCustoms(state,payload){
        //Vue.set(state.selectedUser,'customs',payload)
        //Vue.set(state,'clientUserCustoms',payload)
        //state.selectedUser.customs = payload
    }
}

const actions = {
    fetchUsers(context) {

        //API.endpoints.datis.index + API.constructQueryParams(this.config)
        context.commit('configSort',['name']);
        return axios.get(API.endpoints.users.index + API.constructQueryParams(context.state.config))
            .then(response => {
                context.commit('users', response.data.data)

                context.commit('pagination', response.data.meta.pagination)
            })


    },

    fetchUser(context, payload) {
        return axios.get(API.route(API.endpoints.users.show, {id: payload}))
            .then(response => {
                context.commit('selectedUser', response.data)
            })
    },
    checkMailExists(context, payload){
        return axios.get(API.endpoints.users.checkMailExists+'?email='+payload)
    },

    createUser(context, payload) {

        return axios.post(API.endpoints.users.add, payload.data)
    },

    editUser(context, payload) {
        return axios.put(API.route(API.endpoints.users.edit, {id: payload.id}), payload.data)
    },

    deleteUser(context, payload) {
        return axios.delete(API.route(API.endpoints.users.delete, {id: payload}))
    },

    changePassword(context, payload) {
        //CODE CACA : ajout des champs customs lors du changement de mot de passe sinon les codes EDI pètent une erreur car ils sont obligatoires
        return axios.put(API.route(API.endpoints.users.edit, {id: payload.id}), payload.user)
    },

    fetchRoles(context, payload) {
        return axios.get(API.route(API.endpoints.users.roles, {id: payload}))
            .then(response => {

                let roles = {};

                for (let i = 0; i < response.data.length; i++) {
                    let role = response.data[i];
                    let temp = role.name.split('-');
                    if (!roles[temp[0]]) {
                        roles[temp[0]] = [];
                    }
                    roles[temp[0]].push(role);
                }


                context.commit('selectedUserRoles', roles)
            })
    },
    fetchGroups(context, payload) {
        return axios.get(API.route(API.endpoints.users.groups, {id: payload.id, universe: payload.universe}))
            .then(response => {


                context.commit('selectedUserGroups', {universe: payload.universe, groups: response.data})
            })
    },
    editRoles(context) {


        let payload = {
            roles: []
        };
        let roles = {};
        Object.keys(context.state.selectedUserRoles).map(function (objectKey) {
            let value = context.state.selectedUserRoles[objectKey];
            roles[objectKey] = [];
            if (value[0]) {
                roles[objectKey][0] = value[0].name;
            }

        });


        //console.log(roles);
        payload = roles;


        return axios.post(API.route(API.endpoints.users.roles, {id: context.state.selectedUser.id}), payload)
    },
    editGroups(context) {

        let percentBaseRest = 75 - 25;
        let nbCalls = Object.keys(context.state.selectedUserGroups).length;
        let percentPerCall = percentBaseRest / nbCalls;
        let currentPercent = 25;

        let promisesArray = [];

        Object.keys(context.state.selectedUserGroups).map((objectKey) => {

            let toAdd = []
            let toRemove = []

            function comparer(otherArray) {
                return function (current) {
                    return otherArray.filter(function (other) {
                        return other.id === current.id
                    }).length === 0;
                }
            }

            if(context.state.selectedUserGroupsOrig[objectKey]){

            toRemove = context.state.selectedUserGroupsOrig[objectKey].filter(comparer(context.state.selectedUserGroups[objectKey])).map(function (obj) {
                return obj.id
            });
            toAdd = context.state.selectedUserGroups[objectKey].filter(comparer(context.state.selectedUserGroupsOrig[objectKey])).map(function (obj) {
                return obj.id
            });

            }
            else{
                toAdd = context.state.selectedUserGroups[objectKey].map(function (obj) {
                    return obj.id
                });
            }



            let promisesAdd = new Promise(resolve => {
                resolve()
            })
            let promisesRemove = new Promise(resolve => {
                resolve()
            })

            if (toAdd.length > 0) {
                promisesAdd = axios.post(API.route(API.endpoints.users.groups, {
                    id: context.state.selectedUser.id,
                    universe: objectKey
                }), {
                    groups: toAdd
                })
            }


            if (toRemove.length > 0) {
                promisesRemove = axios.delete(API.route(API.endpoints.users.groups, {
                    id: context.state.selectedUser.id,
                    universe: objectKey
                }), {
                    data: {
                        groups: toRemove
                    }
                })
            }

            promisesArray.push(promisesAdd, promisesRemove);

            Promise.all(promisesArray).then(response => {
                context.commit('UI/loadingProgress',100,{root: true})
                context.dispatch('fetchGroups',{
                    id: context.state.selectedUser.id,
                    universe: objectKey
                })
            })

            Promise.all([promisesAdd, promisesRemove]).then(() => {
                currentPercent += percentPerCall;
                context.commit('UI/loadingProgress',currentPercent,{root: true})
            })

        })

        return Promise.all(promisesArray)

    }
}

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/stores/modules/users/store.js